export default "__VITE_ASSET__C7Cz_4Cc__"